import { LineItems } from 'features/home/types';
import Typography from '../../../typography';
import { ProductSpecificsContainer, PriceContainer } from './styles';
import ProductData from './productData';
export const ProductSpecifics = (props: LineItems) => {
  const {
    unitPrice, quantity, productDiscount = 0,
  } = props;
  const discountedPrice = unitPrice - (productDiscount / quantity);

  return (
    <ProductSpecificsContainer>
      <ProductData {...props} />
      <PriceContainer>
        {productDiscount > 0 && (
          <Typography variant="body-compact-01-linethrough" className="unit-price" noMargin>
            {`£${(unitPrice / 100).toFixed(2)}`}
          </Typography>
        )}
        <Typography variant="body-03" className="unit-price" noMargin>
          {`£${(discountedPrice / 100).toFixed(2)}`}
        </Typography>
        <Typography variant="body-03" className="quantity" noMargin>
          {`x ${quantity}`}
        </Typography>
        <Typography variant="body-03" className="total-price" noMargin>
          {`£${((discountedPrice * quantity) / 100).toFixed(2)}`}
        </Typography>
      </PriceContainer>
    </ProductSpecificsContainer>
  );
};

export default ProductSpecifics;
